import {Typography} from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import {getPerQuestionCorrectStudentAnswers, getQuestionPoints, isAnswerCorrect} from './utils';
import {
    Check,
    Close as CloseIcon,
    SentimentVeryDissatisfied as Sad,
    SentimentVerySatisfied as Happy
} from '@material-ui/icons';

export default function DetailedQuestionResult(props){
    const {quizDataDict, showAnswerKey} = props;
    return (
        <ExpansionPanel>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                <Typography> Detailed Question Breakdown </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
                <div className="content-box width-100">
                    { quizDataDict.questions.map((question, quizQuestionIndex) => (
                        <div key={`question-panel-for-question-${quizQuestionIndex}`}>
                            <Typography>Topic: {question.topic}</Typography>
                            <FeedbackBar currentQuestion={question}/>
                            <div >
                                <div className={'quiz-question-content question-container'}
                                    dangerouslySetInnerHTML={{__html: question.content}}/>
                                <ul className="ul-take-quiz">
                                    { question.answers.map((answer, questionAnswerIndex) => (
                                        <li key={`quiz-question-${questionAnswerIndex}`}>
                                            <div className="quiz-question-list-item-container">
                                                <div className="quiz-question-list-item-indicator">
                                                    {displayFeedbackLabel(question, answer)}
                                                </div>

                                                <div className={'quiz-question-content'}
                                                    dangerouslySetInnerHTML={{__html: answer.content}}/>
                                                {showAnswerKey && displayAnswerIndicator(question, answer, quizDataDict.answers)}
                                            </div>
                                        </li>
                                    ))
                                    }
                                </ul>
                                <hr/>
                            </div>
                        </div>
                    ))}
                </div>
            </ExpansionPanelDetails>
        </ExpansionPanel>
    );
}


function FeedbackBar(props) {

    const {currentQuestion} = props;

    let numCorrectAnswers = getPerQuestionCorrectStudentAnswers(currentQuestion);
    let totalCorrectAnswers = getQuestionPoints(currentQuestion);
    let isCorrect = numCorrectAnswers === totalCorrectAnswers;

    let classText =
        isCorrect ? 'correct-answer bordered bordered-success' : 'incorrect-answer bordered bordered-failure';

    return (
        <div className={classText}>
            <div>
                <FeedbackIcon isCorrect={isCorrect}/>&nbsp;{isCorrect ? 'Correct' : 'Incorrect'}
            </div>
        </div>
    );
}

const FeedbackIcon = ({isCorrect}) => {
    return isCorrect ? <Happy/> : <Sad/>;
};

const displayFeedbackLabel = (question, answer) => {

    if (!question.studentAnswer && !question.studentAnswers){
        return null;
    }

    let answers = [question.studentAnswer].concat(question.studentAnswers)
        .filter(studentAnswer => studentAnswer != null);

    let isCorrect = answers.filter((studentAnswer) => isAnswerCorrect(question,studentAnswer))
        .map((correctAnswer) => correctAnswer.questionAnswerId.$oid).includes(answer.questionAnswerId.$oid);

    if (isCorrect) {
        return <Check className="quiz-check-green"/>;
    } else if (
        answers.map((studentAnswer) => studentAnswer.questionAnswerId.$oid)
            .includes(answer.questionAnswerId.$oid)
    ) {
        return <CloseIcon className="quiz-incorrect-label"/>;
    }

    return null;
};

const displayAnswerIndicator = (question, answer) => {
    let answerId = answer.questionAnswerId.$oid;
    let isThisAnswerCorrect = isAnswerCorrect(question, answer);
    let isStudentAnswer = ([question.studentAnswer].concat(question.studentAnswers))
        .filter(studentAnswer => studentAnswer != null)
        .reduce((result, currentStudentAnswer) => result || currentStudentAnswer.questionAnswerId.$oid === answerId,
            false);

    let returnText = isStudentAnswer ? 'Your Answer' : isThisAnswerCorrect ? 'Correct Answer' : '';
    let returnClass = isThisAnswerCorrect ? 'correct-answer answer-indicator' :
        isStudentAnswer ? 'incorrect-answer answer-indicator' : 'answer-indicator';

    return (
        <div className={returnClass}>
            {returnText}
        </div>
    );

};